import axios from "axios";
import getEnvVariable from "./env";
export default axios.create({
  baseURL: getEnvVariable("REACT_APP_DHK_BASE_URL"),
});
